import {ShapeConstants} from '../utils/penpot/constant';
import {DynamicCss} from '../store/ast/ast.types';
import i18next from "../global/i18n";

export const DESIGNBOARD = 'pointcode-design-board'
export const DESIGN_CONTAINER_RECT = 'design-container-rect'

/** 画布导出图片右下角水印文案 */
export const CANVAS_EXPORT_WATERMARK = '点码科技AI生成';

/** 画布下载是否不带水印，默认 false（带水印） */
export const CANVAS_DOWNLOAD_WITHOUT_WATERMARK = false;

export const EVENT_TYPES = [
  'click', 'dblclick', 'mouseover', 'mouseout', 'mousedown',
  'mouseup', 'mousemove', 'mouseenter', 'mouseleave',
  'keydown', 'keyup', 'clickDone', 'focus','blur',
];


export const EVENT_CONFIG = {
  click: false,
  dblclick: false,
  mouseover: false,
  mouseout: false,
  mousedown: false,
  mouseup: false,
  mousemove: false,
  mouseenter: false,
  mouseleave: false,
  keydown: false,
  keyup: false,
  clickDone: false,
  focus: false,
  blur: false,
};

export const event = (event) => {
  return {
    label: event,
    status: false,
    type: '',
    triggerSetting: {
      functionBody: [],
      customFunctionParams: [],
      customParamsList: [],
    },
  };
};

export const hookEvent = (event) => {
  return {
    label: event,
    triggerSetting: {
      functionBody: [],
      customFunctionParams: [],
      customParamsList: [],
    },
  };
};

export const genDefaultTextCss = () => ({
  color: 'text-[rgba(0,0,0,1)]',
  'line-height': 'leading-4',
  'font-size': 'text-[1rem]',
  'font-weight': 'font-normal',
  'letter-spacing': 'tracking-[0rem]'
});
export const genDefaultImageCss = () => ({
  'background-size': 'bg-contain',
  'background-position': 'bg-center',
  'background-repeat': 'bg-no-repeat'
});

export const genDefaultDynamicCss = (extra?): DynamicCss[] => ([{
  type: 'default',
  bind: 'default',
  sources: [{
    value: 'default',
    expression: 'eq',
    action: 'cover',
    css: {
      normal: {
        position: 'absolute',
        left: 'left-0',
        top: 'top-0',
        width: 'w-325',
        height: 'h-200',
        'background-color': 'bg-[rgba(255,255,255,1)]',
        'z-index': 'z-0',
        'box-sizing': 'box-border',
        ...extra,
      },
    },
  }],
}, {
  type: 'status',
  bind: 'status',
  sources: [
    {value: 'hover', expression: 'eq', action: 'merge', css: {variants: {}}},
    {value: 'focus', expression: 'eq', action: 'merge', css: {variants: {}}},
    {value: 'active', expression: 'eq', action: 'merge', css: {variants: {}}},
    {value: 'visited', expression: 'eq', action: 'merge', css: {variants: {}}},
  ],
}]);

export const ComponentConstants = {
  'x': `css.${ShapeConstants.x}`,
  'y': `css.${ShapeConstants.y}`,
  'width': `css.${ShapeConstants.width}`,
  'height': `css.${ShapeConstants.height}`,
  'selrect': `css.${ShapeConstants.selrect}`,
};


export const FILE_NAME_TYPE = 'custom-atom-';
export const PLUG_IN_NAME_TYPE = 'custom-plug-in-';

export const ATOM_COMP_CONSTANTS = {
  compType: {
    frame: 'frame',
    group: 'group',
    cyclicRegion: 'cyclic-region',
  },
};

export const INIT__COMP_TYPE = [ATOM_COMP_CONSTANTS.compType.frame, ATOM_COMP_CONSTANTS.compType.group, ATOM_COMP_CONSTANTS.compType.cyclicRegion];

/**
 * 拖拽默认值
 */
export const COMP_WIDTH = 30;
export const COMP_HEIGHT = 20;
export const SNAP_RANGE = 20;
export const LEFT_ALIGN_DISTANCE = 100;

const COMP_TYPE_MAP = ()=> ({
  rectangle: i18next.t('label.compTypeMap.rectangle'),                // 矩形
  circle: i18next.t('label.compTypeMap.circle'),                // 圆
  text: i18next.t('label.compTypeMap.text'),                // 文本
  input: i18next.t('label.compTypeMap.input'),                // 输入框
  frame: i18next.t('label.compTypeMap.frame'),                // 画板
  group: i18next.t('label.compTypeMap.group'),                // 组
  'cyclic-region': i18next.t('label.compTypeMap.cyclicRegion'),                // 循环区域
  path: i18next.t('label.compTypeMap.path'),                // 路径
  image: i18next.t('label.compTypeMap.image'),                // 图片
  generator: i18next.t('label.compTypeMap.generator'),                // ID生成器
  richText: i18next.t('label.compTypeMap.richText'),                // 富文本
  icon: i18next.t('label.compTypeMap.icon'),                // 图标
  iframe: "iframe",                // iframe
  bi: i18next.t('label.compTypeMap.bi'),                // 图表
  date: i18next.t('label.compTypeMap.date'),                // 日期
  upload: i18next.t('label.compTypeMap.upload'),                // 上传
  tree: i18next.t('label.compTypeMap.tree'),                // 树
  markdown: 'Markdown',                // Markdown
  canvas: i18next.t('label.compTypeMap.canvas'),                // 画布
  amount: i18next.t('label.compTypeMap.amount'),                // 金额
  pay: i18next.t('label.compTypeMap.pay'),                // 支付
  'three-canvas': '3d',                // 3d
  video: i18next.t('label.compTypeMap.video'),                // 视频
  audio: i18next.t('label.compTypeMap.audio'),                // 音频
  recorder: i18next.t('label.compTypeMap.recorder'),                // 录音
  ttsSpeak: i18next.t('label.compTypeMap.ttsSpeak'),                // 语音播报
  slot: i18next.t('label.compTypeMap.slot'),                // 插槽
  form: i18next.t('label.compTypeMap.form'),                // 表单
  table: i18next.t('label.compTypeMap.table'),                // 表格
  calendar: i18next.t('label.compTypeMap.calendar'),                // 日程
  'qr-code': i18next.t('label.compTypeMap.qrCode'),                // 二维码
  rbac: 'rbac',                 // rbac
  'filter-generator': i18next.t('label.compTypeMap.filterGenerator'),                // 复杂过滤
  'data-selection': i18next.t('label.compTypeMap.dataSelection'),                // 数据选择
  selectChoices: i18next.t('label.compTypeMap.selectChoices'),                // 下拉框
  pagination: i18next.t('label.compTypeMap.pagination'),                // 分页
  chart: i18next.t('label.compTypeMap.chart'),                // 图表
  menu: i18next.t('label.compTypeMap.menu'),                // 菜单
  bpmn:i18next.t('label.compTypeMap.flowDiagram'),                // 流程图
  luckysheet:i18next.t('label.compTypeMap.luckysheet'),              // 报表
  popup:i18next.t('label.compTypeMap.popup')                // 弹窗
});

export const ATOM_COMP_TYPE = ()=>( Object.entries(COMP_TYPE_MAP()).map(([value, label]) => ({
  label,
  value
})));

export const ENUM_TYPE =() =>( [
  {label: i18next.t('label.enumTypes.string'), value: 'string'},  /* 字符串 */
  {label: i18next.t('label.enumTypes.number'), value: 'number'}, /* 数字 */
  {label: i18next.t('label.enumTypes.boolean'), value: 'boolean'}, /* 布尔值 */
  {label: i18next.t('label.enumTypes.object'), value: 'object'}, /* 对象 */
  {label: i18next.t('label.enumTypes.array'), value: 'array'}, /* 数组 */
  {label: i18next.t('label.enumTypes.enum'), value: 'enum'}, /* 枚举 */
  {label: i18next.t('label.enumTypes.destructuring'), value: 'destructuring'}, /* 解构 */
]);

export const StyleConstants = {
  style: {
    backgroundColor: 'backgroundColor',
    marginTop: 'marginTop',
    marginBottom: 'marginBottom',
    marginLeft: 'marginLeft',
    marginRight: 'marginRight',
    paddingTop: 'paddingTop',
    paddingBottom: 'paddingBottom',
    paddingLeft: 'paddingLeft',
    paddingRight: 'paddingRight',
    width: 'width',
    height: 'height',
    color: 'color',
    maxWidth: 'maxWidth',
    minWidth: 'minWidth',
    maxHeight: 'maxHeight',
    minHeight: 'minHeight',
  },
};


export const DND_LANDING_INNER = 1
export const DND_LANDING_OUTER = 2
export const DND_LANDING_OVERLINE = 3

export const MOUSE_ACTION_COMP_DND = 1
export const MOUSE_ACTION_COMP_RESIZE = 2
export const MOUSE_ACTION_COMP_INIT = 3

export const DOCFLOW_LOCATION_NO_OFFSET = new Set(['static', 'sticky'])
export const DOCFLOW_LOCATION = new Set(['static', 'relative', 'sticky'])
export const PARENT_COMP_TYPE = new Set(['frame', 'cyclic-region', 'group', 'form', 'pagination'])
export const POSITION_SIZE_PROPS = new Set(['position', 'top', 'left', 'right', 'bottom'])


// export const EVENT_LIST = [
//   {label: "click时", value: "click"},
//   {label: "bulr时", value: "blur"},
//   {label: "change时", value: "change"},
//   {label: "focus时", value: "focus"},
//   {label: "mouseover时", value: "mouseover"},
//   {label: "mouseout时", value: "mouseout"},
//   {label: "mousedown时", value: "mousedown"},
//   {label: "mouseup时", value: "mouseup"},
//   {label: "mousemove时", value: "mousemove"},
//   {label: "mouseenter时", value: "mouseenter"},
//   {label: "uploadSuccess时", value: "uploadSuccess"},
//   {label: "keyup时", value: "keyup"},
//   {label: "keydown时", value: "keydown"},
//   {label: "mouseleave时", value: "mouseleave"},
//   {label: "down时", value: "down"},
// ]

// 分组常量
const EVENT_GROUP =()=>( {
  WEB: i18next.t('label.eventGroups.web'),              //  Web端事件
  COMMON: i18next.t('label.eventGroups.common'),            //  通用事件
  MOBILE: i18next.t('label.eventGroups.mobile')           //  移动端事件
});

// 2. 简化事件列表定义
export const EVENT_LIST =()=> ([
  // Web端专属事件（鼠标/键盘/焦点类）
  ...["click", "blur", "change", "focus", "mouseover", "mouseout",
    "mousedown", "mouseup", "mousemove", "mouseenter", "keyup",
    "keydown", "mouseleave"].map(eventName => ({
    label: `${eventName}${i18next.t('label.eventSuffix')}`, /* 事件名称后缀"时" */
    value: eventName,
    group: EVENT_GROUP().WEB
  })),

  // 通用事件
  ...["uploadSuccess","tableRowEvent", "down"].map(eventName => ({
    label: `${eventName}${i18next.t('label.eventSuffix')}`, /* 事件名称后缀"时" */
    value: eventName,
    group: EVENT_GROUP().COMMON
  })),

  // 移动端事件
  ...["touchstart", "touchend", "touchmove",'longpress','touchendSuccess'].map(eventName => ({
    label: `${eventName}${i18next.t('label.eventSuffix')}`, /* 事件名称后缀"时" */
    value: eventName,
    group: EVENT_GROUP().MOBILE
  }))
]);


export const EXECUTE_TYPE = ()=> ([
  {label: i18next.t('label.executeTypes.eventConfigPanel'), value: "click"}, /* 事件配置面板 */
]);


export const HOOK_EVENT_LIST = [
  {label: "hook", value: "hook"},
  {label: "beforeLoad", value: "beforeLoad"},
  {label: "connected", value: "connectedCallback"},
  {label: "willLoad", value: "componentWillLoad"},
  {label: "didLoad", value: "componentDidLoad"},
  {label: "willRender", value: "componentWillRender"},
  {label: "didRender", value: "componentDidRender"},
  {label: "willUpdate", value: "componentWillUpdate"},
  {label: "didUpdate", value: "componentDidUpdate"},
  {label: "disconnected", value: "disconnectedCallback"},
]


export const MULTIPLE_ROUNDS_TYPES =()=>( [
  {label: i18next.t('label.multipleRoundsTypes.pageDesign'), value: "page_design"},  /* 页面设计 */
  {label: i18next.t('label.multipleRoundsTypes.bpmnDesign'), value: "bpmn_design"},  /* 流程列表 */
  {label: i18next.t('label.multipleRoundsTypes.reportDesign'), value: "report_design"}, /* 报表列表 */
]);

export const PROCESS_INSTANCE_STATUS =()=>( [
  {
    label: i18next.t('label.processInstanceStatus.completed'), /* 已完成 */
    value: 'COMPLETED'
  },
  {
    label: i18next.t('label.processInstanceStatus.rejected'), /* 已拒绝 */
    value: 'REJECTED'
  },
  {
    label: i18next.t('label.processInstanceStatus.active'),   /* 处理中 */
    value: 'ACTIVE'
  }
]);


export const IMPORT_MODEL = ()=>([
  {
    value: 'append',
    label: i18next.t('label.importModel.append')  /* 追加：添加数据到目标对象 */
  },
  {
    value: 'uniqueAppend',
    label: i18next.t('label.importModel.uniqueAppend')  /* 追加跳过重复：如果目标存在相同数据时跳过，既不添加也不更新 */
  },
  {
    value: 'update',
    label: i18next.t('label.importModel.update')  /* 更新：仅更新目标和源相符的数据 */
  },
  {
    value: 'appendAndUpdate',
    label: i18next.t('label.importModel.appendAndUpdate') /* 追加或更新：如果目标存在相同数据，更新它，否则添加 */
  },
  {
    value: 'delete',
    label: i18next.t('label.importModel.delete') /* 删除：删除目标中和源记录相符数据 */
  },
  {
    value: 'copy',
    label: i18next.t('label.importModel.copy')  /* 覆盖： 删除目标全部数据，并从源重新导入 */
  }
]);


// 订单数据加密 key（16位）
export const ORDER_DATA_ENCRYPT_KEY = 'P6B8qxy2WGqwu3vB';
// 订单数据加密 iv（16位）
export const ORDER_DATA_ENCRYPT_IV = 'CHxWFGFnVlPqu6EE';



export const linkType = {
  MENU:'menu',
  CHART:'chart',
  DATAREPORT:'dataReport'
}

export const FROZEN_KEY = 'login_access_frozen'
export const OPENID_KEY = 'login_wechat_openid'


export const ACCOUNT_REGEXP = {
  reg: /^[a-zA-Z][\w]*$/,
  desc: '英文字母、数字、下划线的组合，且以字母开头'
}



export const PASSWORD_REGEXP = {
  reg: /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*-_/])[\da-zA-Z~!@#$%^&*-_/]{8,}$/,
  desc: '必须包含英文字母、数字、特殊符号~!@#$%^&*-_/且8位以上'
}